const STORAGE_KEY = "pos_last_ticket";

export function formatTicketMoney(value) {
  const n = Number(value) || 0;
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}

export function formatTicketMoneyWithSymbol(value) {
  return `$ ${formatTicketMoney(value)}`;
}

export function formatTicketDate(dateInput) {
  const d = dateInput ? new Date(dateInput) : new Date();
  return d.toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function buildInvoiceNumber(remissionId) {
  return `FV${String(remissionId).padStart(8, "0")}`;
}

export function savePosTicketData(payload) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

export function loadPosTicketData(remissionId = null) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (remissionId != null && String(data.remissionId) !== String(remissionId)) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function resolveCompanyLogoUrl(company = {}) {
  const base =
    process.env.VUE_APP_API_IMAGE_URL ||
    process.env.VUE_APP_API_BASE_URL ||
    "";
  const path = company.logo_path || company.logo_path_dark;
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedBase = String(base).replace(/\/$/, "");
  const normalizedPath = String(path).replace(/^\//, "");
  return `${normalizedBase}/${normalizedPath}`;
}

export function mergeTicketCompany(ticket, company = {}) {
  if (!ticket) return ticket;
  return {
    ...ticket,
    company: {
      company_name: company.company_name ?? ticket.company?.company_name ?? "",
      nit: company.nit ?? ticket.company?.nit ?? "",
      description: company.description ?? ticket.company?.description ?? "",
      phone: company.phone ?? ticket.company?.phone ?? "",
      address: company.address ?? ticket.company?.address ?? "",
      email: company.email ?? ticket.company?.email ?? "",
      logo_path: company.logo_path ?? ticket.company?.logo_path ?? "",
      logo_path_dark: company.logo_path_dark ?? ticket.company?.logo_path_dark ?? "",
    },
  };
}

export function buildTicketPayload({ remissionId, client, cart, totals, paymentMethod, amountPaid, sellerName, company }) {
  const items = (cart || []).map((item) => ({
    name: String(item.name || "").toUpperCase(),
    ref: item.ref || null,
    quantity: item.quantity,
    unitPrice: item.unit_price,
    total: item.unit_price * item.quantity,
  }));

  const articlesCount = items.reduce((sum, i) => sum + Number(i.quantity || 0), 0);
  const total = Number(totals.total || 0);
  const received = Number(amountPaid || total);
  const change = Math.max(0, received - total);

  return {
    remissionId,
    invoiceNo: buildInvoiceNumber(remissionId),
    dateFormatted: formatTicketDate(new Date()),
    client: {
      id: client?.id || null,
      name: client?.name || "CONSUMIDOR FINAL",
      document_type: client?.document_type || "CC",
      document: client?.document || String(client?.id || ""),
    },
    items,
    subtotal: Number(totals.subtotal || 0),
    itemsTotal: items.reduce((sum, i) => sum + Number(i.total || 0), 0),
    discountAmount: Number(totals.discountAmount || 0),
    flete: Number(totals.flete || 0),
    giftValue: Number(totals.giftValue || 0),
    total,
    received,
    change,
    paymentMethod: paymentMethod || "EFECTIVO",
    articlesCount,
    itemsCount: items.length,
    seller: String(sellerName || "LOCAL").toUpperCase(),
    company: company || {},
  };
}

export function openPosTicketWindow(router, remissionId) {
  const route = router.resolve({
    name: "POS Ticket",
    query: { id: String(remissionId) },
  });
  window.open(route.href, "_blank");
}
